import { render } from "./FaqItem.vue?vue&type=template&id=fdc455bc&ts=true"
import script from "./FaqItem.vue?vue&type=script&lang=ts"
export * from "./FaqItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__